// Minimal Markdown renderer for digests & articles (headings, bold, bullets, paragraphs).
function inline(text) {
  const parts = [];
  const regex = /\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`/g;
  let last = 0;
  let m;
  let key = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1]) parts.push(<strong key={key++} className="text-zinc-50 font-semibold">{m[1]}</strong>);
    else if (m[2]) parts.push(<em key={key++}>{m[2]}</em>);
    else if (m[3]) parts.push(<code key={key++} className="font-mono text-emerald-300 bg-emerald-950/40 px-1 rounded">{m[3]}</code>);
    last = regex.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export default function Markdown({ content, className = "" }) {
  if (!content) return null;
  const lines = content.split("\n");
  const blocks = [];
  let list = [];
  const flush = (k) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${k}`} className="list-disc pl-5 space-y-1.5 my-3 text-zinc-300">
          {list.map((li, i) => <li key={i}>{inline(li)}</li>)}
        </ul>
      );
      list = [];
    }
  };
  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (/^###\s/.test(line)) { flush(i); blocks.push(<h3 key={i} className="text-lg font-bold font-serif text-zinc-50 mt-5 mb-2">{inline(line.replace(/^###\s/, ""))}</h3>); }
    else if (/^##\s/.test(line)) { flush(i); blocks.push(<h2 key={i} className="text-xl sm:text-2xl font-bold font-serif text-zinc-50 mt-6 mb-2">{inline(line.replace(/^##\s/, ""))}</h2>); }
    else if (/^#\s/.test(line)) { flush(i); blocks.push(<h1 key={i} className="text-2xl sm:text-3xl font-extrabold font-serif text-zinc-50 mt-2 mb-3">{inline(line.replace(/^#\s/, ""))}</h1>); }
    else if (/^[-*]\s/.test(line)) { list.push(line.replace(/^[-*]\s/, "")); }
    else if (line.trim() === "") { flush(i); }
    else { flush(i); blocks.push(<p key={i} className="text-zinc-300 leading-relaxed my-2">{inline(line)}</p>); }
  });
  flush("end");
  return <div className={className}>{blocks}</div>;
}
